import type { Todo } from "../../domain/entities.ts";
import { currentTimezone, formatDate } from "../../ui/date.ts";
import { projectedRecurringDates } from "./recurrence.ts";
import { recurrenceFromForm } from "./task-form-mapper.ts";
import { resolveWallTime } from "./task-time.ts";

export function recurrencePreview(todo: Todo, format: (date: string) => string = formatDate): string {
  if (!todo.recurrence) return "";
  if (todo.recurrence.basis === "completion") return "The next date is calculated when you complete this task.";
  if (!todo.dueDate && !todo.startDate && !todo.startAt) return "Add a start or due date to preview upcoming dates.";
  try {
    const dates = projectedRecurringDates(todo, 3);
    return dates.length ? `Next dates: ${dates.map(format).join(" · ")}` : "No more dates remain under this repeat rule.";
  } catch { return "Check the schedule to preview upcoming dates."; }
}

export function updateRecurrencePreview(form: HTMLFormElement, format: (date: string) => string = formatDate): void {
  const editor = form.querySelector<HTMLElement>("[data-recurrence-editor]");
  const target = editor?.querySelector<HTMLElement>("[data-recurrence-preview]");
  if (!editor || !target) return;
  const previous = JSON.parse(editor.dataset.recurrenceContext || "{}") as Todo;
  const data = new FormData(form);
  const value = (name: string) => String(data.get(name) || "");
  const timezone = value("scheduleMode") === "floating" ? value("scheduleTimeZone") : previous.recurrence?.timezone || editor.dataset.recurrenceTimezone || currentTimezone();
  const recurrence = recurrenceFromForm(data, previous.recurrence, timezone);
  let text: string;
  try {
    const start = value("startAt");
    const startAt = start ? value("scheduleMode") === "floating" ? resolveWallTime(start, timezone) : new Date(start).toISOString() : null;
    text = recurrencePreview({ ...previous, recurrence, dueDate: value("dueDate") || null, startDate: value("startDate") || null, startAt }, format);
  } catch { text = "Check the schedule to preview upcoming dates."; }
  if (target.textContent !== text) target.textContent = text;
  target.hidden = !recurrence;
  const timezoneLabel = editor.querySelector<HTMLElement>("[data-recurrence-timezone-label]");
  if (timezoneLabel) timezoneLabel.textContent = timezone;
}
